import { Component, Vue, Prop as prop, Prop} from 'nuxt-property-decorator';

@Component({
    components: {
        imageRow: require('../configurator-image-row').default,
        textRow: require('../configurator-text-row').default,
        groupRow: require('../configurator-group-row').default,
    }
})
export default class ConfiguratorRow extends Vue {

    @Prop() refs: any[];
    @Prop() option;
    @Prop() idx: number;
    @Prop() variants;
    @Prop() current;

    get matchedOffers() {

        const offersGrade = new Map();
        const matched = new Map();

        this.refs.forEach((ref) => {

            let grade = 0;
            let optionKey = null;

            for (let i = 0; i < ref.keys.length; i++) {
                if (i === this.idx) {
                    optionKey = ref.keys[i]
                    continue;
                }

                if (this.current.keys[i] === ref.keys[i]) {
                    grade |= (1 << (ref.keys.length - i + 1));
                }
            }

            const info = {shaded: false, offer: ref};

            if (this.variants.length === 1) {
                matched.set(optionKey, info);
                return;
            }

            if (!grade) {
                info.shaded = true;
            }

            if (matched.has(optionKey) && offersGrade.get(optionKey) >= grade || !ref) {
                return;
            }

            matched.set(optionKey, info);
            offersGrade.set(optionKey, grade);
        });

        return matched;
    }

    get showLabel() {
        return Object.keys(this.variants).length > 1;
    }
}
